export default {
  NO_PERMISSION_DIALOG_SET_STATE: 'NO_PERMISSION_DIALOG_SET_STATE'
};
